import { BoxSize } from "../../Types";

export default {
  findCanvasElement,
  clearImages,
  clearActiveObjects,
  deleteActiveObject,
  handleCanvasSize,
  cmToPx,
  wordBreak,
};

/**
 * @method findCanvasElement
 * @param id {string} Object's id when initialized
 * @param canvas {fabricCanvasInstance} Fabric instance that is to be edited
 * @returns {fabric.Canvas | null}
 * @description Method used to find element in canvas
 */
export function findCanvasElement(id: string, canvas: fabric.Canvas): any {
  let fabricObject = null;
  canvas.getObjects().forEach(function(object) {
    //@ts-ignore
    if (object.id === id) {
      fabricObject = object;
    }
  });
  return fabricObject;
}

export function clearImages(canvas: fabric.Canvas): void {
  canvas.getObjects().forEach(function(object) {
    //@ts-ignore
    if (object.type === "image" || object.customType === "image") {
      canvas.remove(object);
    }
  });
}

function clearActiveObjects(canvas: fabric.Canvas) {
  // for each click exit from text edit mode
  let allObjects = canvas.getObjects();
  allObjects.map((object: fabric.Object) => {
    if (object.type == "i-text") {
      // @ts-ignore
      object.exitEditing();
    }
  });
  canvas.discardActiveObject();
  canvas.renderAll();
}

export function deleteActiveObject(canvas: fabric.Canvas) {
  // clear from canvas current selected objects
  canvas.remove(...canvas.getActiveObjects());
}

/**
 * @method handleCanvasSize
 * @param dpi {number} Product paper dpi
 * @param paperWidth {number} Product paper width
 * @param paperHeight {number} Product paper height
 * @returns {BoxSize}
 * @description Method used to calculate real size of the canvas based on paper config.
 */
export function handleCanvasSize(
  dpi: number,
  paperWidth: number,
  paperHeight: number
): BoxSize {
  try {
    let dpmm = dpi / 25.4;
    let width = ((paperWidth * 10) / 3) * dpmm;
    let height = ((paperHeight * 10) / 3) * dpmm;
    return {
      width: width,
      height: height,
    };
  } catch (e) {
    throw new Error(`${e}. Could not calculate canvas size.`);
  }
}

export function cmToPx(cm: number, dpi): number {
  let dpmm = dpi / 25.4;
  return cm * 10 * dpmm;
}

export function wordBreak(word: string, characterSize: number): string {
  let formattedWord = [];

  word.split(" ").forEach((str) => {
    if (str.length < characterSize) {
      if (str != "") {
        formattedWord.push(str);
      }
    } else {
      formattedWord.push(str.substr(0, characterSize - 1));
      formattedWord.push(str.substr(characterSize - 1, str.length - 1));
    }
  });
  return formattedWord.join(" ");
}
